module.exports = __webpack_public_path__ + "img/zhubiao.4bbaaa0d.webp";